var MaterialPassBase = (function () {
    function MaterialPassBase() {
    }
    return MaterialPassBase;
}());
export { MaterialPassBase };
